export default function Footer() {
  return (
    <footer id="footer" className="bg-background-900 text-background-200">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-[1280px] mx-auto">
          <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-8">
            <div className="col-span-2 lg:col-span-2">
              <div className="flex items-center gap-2 mb-4">
                <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                  <i className="ri-play-circle-fill text-background-50 text-xl"></i>
                </div>
                <span className="text-lg font-bold text-background-50 font-heading">91视频网站</span>
              </div>
              <p className="text-sm text-background-400 leading-relaxed mb-4 max-w-sm">
                91视频网站是国内领先的综合在线视频平台，提供海量高清电影、电视剧、综艺、动漫免费在线观看。每日更新最新影视资源，支持多端同步播放，为亿万用户打造极致的观影体验。
              </p>
              <div className="flex items-center gap-3">
                <a href="#" className="w-9 h-9 rounded-lg bg-background-800 flex items-center justify-center hover:bg-primary-500 transition-colors cursor-pointer" aria-label="微博">
                  <i className="ri-weibo-line text-background-300 text-lg"></i>
                </a>
                <a href="#" className="w-9 h-9 rounded-lg bg-background-800 flex items-center justify-center hover:bg-primary-500 transition-colors cursor-pointer" aria-label="微信">
                  <i className="ri-wechat-line text-background-300 text-lg"></i>
                </a>
                <a href="#" className="w-9 h-9 rounded-lg bg-background-800 flex items-center justify-center hover:bg-primary-500 transition-colors cursor-pointer" aria-label="哔哩哔哩">
                  <i className="ri-bilibili-line text-background-300 text-lg"></i>
                </a>
                <a href="#" className="w-9 h-9 rounded-lg bg-background-800 flex items-center justify-center hover:bg-primary-500 transition-colors cursor-pointer" aria-label="抖音">
                  <i className="ri-tiktok-line text-background-300 text-lg"></i>
                </a>
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">快速导航</h4>
              <ul className="space-y-2.5">
                <li><a href="#hero" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer">首页</a></li>
                <li><a href="#ranking" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer">影视榜单</a></li>
                <li><a href="#cards" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer">精选推荐</a></li>
                <li><a href="#updates" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer">最新动态</a></li>
                <li><a href="#faq" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer">常见问题</a></li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">内容分类</h4>
              <ul className="space-y-2.5">
                <li><a href="#cards" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer">电影</a></li>
                <li><a href="#cards" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer">电视剧</a></li>
                <li><a href="#media" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer">综艺</a></li>
                <li><a href="#media" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer">动漫</a></li>
                <li><a href="#carousel" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer">纪录片</a></li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">合作伙伴</h4>
              <ul className="space-y-2.5">
                <li><span className="text-sm text-background-500">优质影视制作机构</span></li>
                <li><span className="text-sm text-background-500">正版内容提供商</span></li>
                <li><span className="text-sm text-background-500">技术合作伙伴</span></li>
                <li><span className="text-sm text-background-500">发行与宣传伙伴</span></li>
              </ul>
            </div>
          </div>

          <div className="mt-10 pt-8 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-500">
              &copy; 2026 91视频网站. All rights reserved. 本站内容仅供个人学习交流使用。
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors cursor-pointer">用户协议</a>
              <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors cursor-pointer">隐私政策</a>
              <a href="#contact" className="text-xs text-background-500 hover:text-background-300 transition-colors cursor-pointer">联系我们</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}